<!-- 积分设置 -->
<template>
  <div style="padding: 20px">
    <div class="bodycontent">
      <el-form label-width="auto" >
        <el-form-item label="关闭/开启">
          <el-switch
            v-model="form.open"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="适用油品" prop="goods_ids">
          <el-checkbox-group v-model="form.goods_ids">
            <template v-for="(item, i) in shopsList">
              <el-checkbox :label="item.id" :key="i">{{
                item.name
              }}</el-checkbox>
            </template>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="适用会员级别" prop="level_ids">
          <el-select
            size="small"
            v-model="form.level_ids"
            multiple
            filterable
            collapse-tags
            placeholder="请选择"
          >
            <el-option-group
              v-for="group in vipList"
              :key="group.id"
              :label="group.name"
            >
              <el-option
                v-for="item in group.lists"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="时间类型" prop="time_status">
          <el-radio-group v-model="form.time_status">
            <el-radio :label="0">固定时间段</el-radio>
            <el-radio :label="1">按周期时间</el-radio>
          </el-radio-group>
          <div v-if="form.time_status == 0">
            <el-date-picker
              size="small"
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
          <div v-if="form.time_status == 1">
            <div>
              <el-radio
                v-model="form.day_status"
                :label="1"
                @change="Radio($event, '每天')"
              >
                每天
                <el-time-picker
                  size="small"
                  :disabled="form.day_status != 1"
                  style="width: 100px;margin-left: 10px"
                  v-model="form.day_value.start_time"
                  placeholder="开始"
                  value-format="HH:mm"
                  format="HH:mm"
                >
                </el-time-picker>
                至
                <el-time-picker
                  size="small"
                  :disabled="form.day_status != 1"
                  style="width: 100px;margin-left: 10px"
                  value-format="HH:mm"
                  format="HH:mm"
                  v-model="form.day_value.end_time"
                  placeholder="结束"
                >
                </el-time-picker>
              </el-radio>
            </div>
            <div>
              <el-radio
                v-model="form.month_status"
                :label="1"
                @change="Radio($event, '每月')"
              >
                每月
                <el-select
                  multiple
                  collapse-tags
                  :disabled="form.month_status != 1"
                  v-model="form.month_value.number"
                  size="small"
                  style="margin-left: 10px;width: 130px;"
                >
                  <el-option
                    v-for="item in monthOptions"
                    :key="item"
                    :value="item"
                    >{{ item }}</el-option
                  >
                </el-select>
                日
                <el-time-picker
                  size="small"
                  :disabled="form.month_status != 1"
                  style="width: 100px;margin-left: 10px"
                  v-model="form.month_value.start_time"
                  placeholder="开始"
                  value-format="HH:mm"
                  format="HH:mm"
                >
                </el-time-picker>
                至
                <el-time-picker
                  size="small"
                  :disabled="form.month_status != 1"
                  style="width: 100px;margin-left: 10px"
                  value-format="HH:mm"
                  format="HH:mm"
                  v-model="form.month_value.end_time"
                  placeholder="结束"
                >
                </el-time-picker>
              </el-radio>
            </div>
            <div>
              <el-radio
                v-model="form.week_status"
                :label="1"
                @change="Radio($event, '每周')"
              >
                每周
                <el-checkbox-group
                  size="small"
                  style="display: inline-block;line-height: 10px"
                  v-model="checkboxGroup"
                  :disabled="form.week_status != 1"
                >
                  <el-checkbox-button
                    v-for="item in weeks"
                    :label="item.value"
                    :key="item.value"
                    >{{ item.name }}</el-checkbox-button
                  >
                </el-checkbox-group>

                <el-time-picker
                  size="small"
                  :disabled="form.week_status != 1"
                  style="width: 100px;margin-left: 10px"
                  v-model="form.week_value.start_time"
                  placeholder="开始"
                  value-format="HH:mm"
                  format="HH:mm"
                >
                </el-time-picker>
                至
                <el-time-picker
                  size="small"
                  :disabled="form.week_status != 1"
                  style="width: 100px;margin-left: 10px"
                  value-format="HH:mm"
                  format="HH:mm"
                  v-model="form.week_value.end_time"
                  placeholder="结束"
                >
                </el-time-picker>
              </el-radio>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="规则设置" prop="rule">
          最低消费
          <el-input
            size="small"
            class="input_box"
            v-model="form.rule.min"
          ></el-input>
          元 |
          <el-input
            size="small"
            class="input_box"
            v-model="form.rule.point"
          ></el-input>
          积分抵扣
          <el-input
            size="small"
            class="input_box"
            v-model="form.rule.amount"
          ></el-input>
          元 | 最高抵扣订单金额
          <el-input size="small" class="input_box" v-model="form.rule.rate">
            <template slot="suffix">%</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保 存</el-button>
          <el-button @click="back">返 回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { point_config_add, point_config_detail, point_config_edit } from "@/api/pointSetting";
import { goodsList, levelGroupSelect } from "@/api/vip";
import { mapGetters } from "vuex";
import { delObj } from "@/utils/public";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {},
  data() {
    return {
      form: {
        goods_ids: [],
        level_ids: [],
        month_value: {
          number: "",
          start_time: "00:00",
          end_time: "23:59"
        },
        day_value: {
          start_time: "00:00",
          end_time: "23:59"
        },
        week_value: {
          start_time: "00:00",
          end_time: "23:59"
        },
        rule: {
          min: "",
          point: "",
          amount: "",
          rate: ""
        }
      },
      monthOptions: [],
      shopsList: [],
      vipList: [],
      date: [],
      checkboxGroup: ["1", "2", "3", "4", "5", "6", "7"],
      weeks: [
        { value: "1", name: "周一" },
        { value: "2", name: "周二" },
        { value: "3", name: "周三" },
        { value: "4", name: "周四" },
        { value: "5", name: "周五" },
        { value: "6", name: "周六" },
        { value: "7", name: "周日" }
      ],

    };
  },
  mounted() {
    this.init();
    this.monthOptions = new Array(31)
      .toString()
      .split(",")
      .map(function(item, index) {
        var realNum = String(index + 1);
        if (realNum < 10) {
          return "0" + realNum;
        } else {
          return realNum;
        }
      });
  },
  methods: {
    init() {
      this.get_goods();
      this.get_levelGroupSelect();
      this.$nextTick(() => {
        if (this.$route.query.id) {
          this.get_reulinfo(this.$route.query.id);
        }
      });
    },
    back() {
      this.$router.push("pointSetting");
    },
    async get_goods() {
      let data = {
        app_id: this.app_id,
        store_id: 0
      };
      const res = await goodsList(data);
      if (res.code == 200) {
        this.shopsList = res.data;
      }
    },
    async get_levelGroupSelect() {
      const res = await levelGroupSelect({ app_id: this.app_id });
      if (res.code == 200) {
        this.vipList = res.data;
      }
    },
    Radio(e, key) {
      switch (key) {
        case "每天":
          this.form.day_status = 1;
          this.form.month_status = 0;
          this.form.week_status = 0;
          break;
        case "每月":
          this.form.day_status = 0;
          this.form.month_status = 1;
          this.form.week_status = 0;
          break;
        case "每周":
          this.form.day_status = 0;
          this.form.month_status = 0;
          this.form.week_status = 1;
          break;
      }
      this.$forceUpdate();
    },
    async get_reulinfo(id) {
      const res = await point_config_detail({ app_id: this.app_id, id: id });
      if (res.code == 200) {
        this.form = res.data;
        this.form.goods_ids = res.data.goods_ids.split(",").map(Number);
        this.form.level_ids = res.data.level_ids.split(",").map(Number);
        if (res.data.time_status == 0) {
          this.date[0] = res.data.start_time;
          this.date[1] = res.data.end_time;
          console.log(this.date);
        }
        if (!res.data.day_value) {
          this.form.day_value = {};
        }
        if (!res.data.week_value) {
          this.form.week_value = {};
        }
        if (!res.data.month_value) {
          this.form.month_value = {};
        }
        if (res.data.time_status == 1) {
          if (res.data.month_status == 1) {
            this.form.month_value.number = res.data.month_value.number.split(
              ","
            );
          }
          if (res.data.week_status == 1) {
            this.checkboxGroup = [];
            var week = res.data.week_value.week;
            if (week.Mon == "1") {
              this.checkboxGroup.push("1");
            }
            if (week.Tue == "1") {
              this.checkboxGroup.push("2");
            }
            if (week.Wed == "1") {
              this.checkboxGroup.push("3");
            }
            if (week.Thur == "1") {
              this.checkboxGroup.push("4");
            }
            if (week.Fri == "1") {
              this.checkboxGroup.push("5");
            }
            if (week.Sat == "1") {
              this.checkboxGroup.push("6");
            }
            if (week.Sun == "1") {
              this.checkboxGroup.push("7");
            }
          }
          console.log(this.checkboxGroup);
        }
      }
    },
    async save() {
      this.form.goods_ids = this.form.goods_ids.join(",");
      this.form.level_ids = this.form.level_ids.join(",");
      if (this.form.time_status == 0) {
        this.form.start_time = this.date[0];
        this.form.end_time = this.date[1];
      }
      if (this.form.time_status == 1) {
        if (this.form.month_status == 1) {
          this.form.month_value.number = this.form.month_value.number.join(",");
        }
        if (this.form.week_status == 1) {
          this.form.week_value.week = {
            Mon: this.checkboxGroup.some(x => x == "1") ? "1" : "0",
            Tue: this.checkboxGroup.some(x => x == "2") ? "1" : "0",
            Wed: this.checkboxGroup.some(x => x == "3") ? "1" : "0",
            Thur: this.checkboxGroup.some(x => x == "4") ? "1" : "0",
            Fri: this.checkboxGroup.some(x => x == "5") ? "1" : "0",
            Sat: this.checkboxGroup.some(x => x == "6") ? "1" : "0",
            Sun: this.checkboxGroup.some(x => x == "7") ? "1" : "0"
          };
        }
      }
      let data = {
        ...this.form,
        app_id: this.app_id
      };
      if (this.$route.query.id) {
        data.id = this.$route.query.id;
        data = delObj(data, [
          "create_time",
          "delete_time",
          "goods",
          "scene",
          "update_time"
        ]);
        const res = await point_config_edit(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.$router.push("pointSetting");
        } else {
          this.$message.error(res.msg);
          this.form.goods_ids = this.form.goods_ids.split(",").map(Number);
          this.form.level_ids = this.form.level_ids.split(",").map(Number);
          if (this.form.time_status == 1&&this.form.month_status == 1) {
            this.form.month_value.number = this.form.month_value.number.split(
              ","
            );
          }
        }
      } else {
        const res = await point_config_add(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.$router.push("pointSetting");
        } else {
          this.$message.error(res.msg);
          this.form.goods_ids = this.form.goods_ids.split(",").map(Number);
          this.form.level_ids = this.form.level_ids.split(",").map(Number);
          if (this.form.time_status == 1&&this.form.month_status == 1) {
            this.form.month_value.number = this.form.month_value.number.split(
              ","
            );
          }
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bodycontent {
  position: relative;
  padding: 0px 27px 0;
  font-size: 14px;
  height: 96%;

  display: flex;
  flex-direction: column;
  .option {
    height: 75px;
    line-height: 75px;
    display: flex;
    .left {
      flex: 1;
    }
    .right {
      text-align: right;
      span {
        margin-left: 30px;
        .el-select {
          width: 150px;
        }
      }
    }
  }
  .dflex {
    display: flex;
    flex-wrap: wrap;
    flex: 1;

    .flexleft {
      flex: 1;
      min-width: 500px;
      margin-top: 10px;
    }
  }
  .form_line {
    // border:1px solid #eee;
    height: 40px;
    line-height: 40px;
    display: flex;
    width: auto;
    .bdright {
      padding: 0 10px;
      text-align: center;
    }
  }
}
.input_box {
  width: 120px;
}
</style>
